import { COURSE_LANDING_URL } from '@/constants';
import type { Course } from '@/types';

export type GNBDropdownMenu = {
  type: 'dropdown';
  name: string;
  items: GNBDropdownMenuItem[];
};

type CustomBadge = { color: string; backgroundColor: string; name: string };

export type GNBDropdownMenuItem = {
  name: string;
  description: string;
  detailItems: {
    name: string;
    url: string;
    courseType: Course;
    newTab?: boolean;
    customBadge?: CustomBadge;
  }[];
  iconImage?: string;
  backgroundImage?: string;
};

export type GNBLinkMenu = {
  type: 'link';
  name: string;
  url: string;
  newTab?: boolean;
  customBadge?: CustomBadge;
};

export const GNB_MENUS: (GNBDropdownMenu | GNBLinkMenu)[] = [
  {
    name: '교육',
    type: 'dropdown',
    items: [
      {
        name: '정규 부트캠프',
        description: '100여 명의 현직자 동료들과 필수 키워드 정복',
        detailItems: [
          {
            name: '항해 플러스 백엔드',
            courseType: '플러스 백엔드 코스',
            url: COURSE_LANDING_URL.HANGHAE_PLUS_BACKEND,
          },
          {
            name: '항해 플러스 프론트엔드',
            courseType: '플러스 프론트엔드 코스',
            url: COURSE_LANDING_URL.HANGHAE_PLUS_FRONTEND,
          },
        ],
      },
      {
        name: '강의 패키지',
        description: '자유로운 시간에 참여하는 저연차 필수 코스',
        detailItems: [
          {
            name: '항해 Lite 백엔드',
            courseType: '플러스 Lite 백엔드 코스',
            url: COURSE_LANDING_URL.HANGHAE_PLUS_LITE_BACKEND,
          },
          {
            name: '항해 Lite 프론트엔드',
            courseType: '플러스 Lite 프론트엔드 코스',
            url: COURSE_LANDING_URL.HANGHAE_PLUS_LITE_FRONTEND,
            newTab: true,
          },
        ],
      },
    ],
  },
  {
    name: '항해 스토리',
    type: 'link',
    url: '/plus/story',
  },
  {
    name: '합격 이력서',
    type: 'link',
    url: '/resume',
  },
  {
    name: '수강 후기',
    type: 'link',
    url: '/blog',
    newTab: true,
  },
];

export const GNB_ELEMENT_ID = 'gnb';
